import React from 'react';
import './Modals.css'; // Zakładam wspólny plik CSS dla modali, kod poniżej

const ProfileModal = ({ onClose, onChangePassword }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content profile-modal">
                <div className="modal-header">
                    <h3>👤 Profil</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <div className="input-group">
                        <label>Adres email</label>
                        <input type="email" value="adresemail@adre.com" readOnly />
                    </div>
                    <div className="input-group">
                        <label>Hasło</label>
                        <input type="password" value="***********" readOnly />
                    </div>
                    <div className="modal-actions-link">
                        <span className="link-green" onClick={onChangePassword}>Zmień hasło</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileModal;